"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _SMSSettings = require("@/api/messagePush/SMSSettings.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SmsSettings',
  data: function data() {
    return {
      ruleForm: {
        aliAccessKey: '',
        aliAccessSecret: '',
        aliEndPoint: '',
        smsName: '',
        smsCode: '',
        content: ''
      },
      rules: {},
      ruleForm1: {
        // baseUrl: '',
        accountId: '',
        password: '',
        productId: '',
        smsName: '',
        // smsCode: '',
        content: ''
      },
      rules1: {},
      inUse: ''
    };
  },
  created: function created() {
    this.getConfig();
  },
  methods: {
    getConfig: function () {
      var _getConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, aliConfig, umcConfig, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _SMSSettings.getConfig)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.inUse = res.data.inUse;
                aliConfig = res.data.aliConfig;
                this.ruleForm.aliAccessKey = aliConfig.aliAccessKey;
                this.ruleForm.aliAccessSecret = aliConfig.aliAccessSecret;
                this.ruleForm.aliEndPoint = aliConfig.aliEndPoint;
                this.ruleForm.smsName = aliConfig.aliSmsName;
                this.ruleForm.smsCode = aliConfig.aliSmsCode;
                this.ruleForm.content = aliConfig.aliContent;
                umcConfig = res.data.umcConfig; // this.ruleForm1.baseUrl = umcConfig.baseUrl
                this.ruleForm1.accountId = umcConfig.accountId;
                this.ruleForm1.password = umcConfig.password;
                this.ruleForm1.productId = umcConfig.productId;
                this.ruleForm1.smsName = umcConfig.umcSmsName;
                // this.ruleForm1.smsCode = umcConfig.umcSmsCode
                this.ruleForm1.content = umcConfig.umcContent;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getConfig() {
        return _getConfig2.apply(this, arguments);
      }
      return getConfig;
    }(),
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否保存此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.editAliConfig();
          });
        } else {
          return false;
        }
      });
    },
    editAliConfig: function () {
      var _editAliConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _SMSSettings.editAliConfig)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.getConfig();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function editAliConfig() {
        return _editAliConfig2.apply(this, arguments);
      }
      return editAliConfig;
    }(),
    submitForm1: function submitForm1(formName) {
      var _this2 = this;
      console.log('formName', formName);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否保存此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.editUMConfig();
          });
        } else {
          return false;
        }
      });
    },
    editUMConfig: function () {
      var _editUMConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm1);
              _context3.n = 1;
              return (0, _SMSSettings.editUMConfig)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.getConfig();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function editUMConfig() {
        return _editUMConfig2.apply(this, arguments);
      }
      return editUMConfig;
    }(),
    onSetDefault: function onSetDefault(value) {
      var _this3 = this;
      this.$confirm('确认设置当前平台为默认短信服务商?确认后，原先默认账号将被替换，谨慎操作!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.defaultConfig(value);
      });
    },
    defaultConfig: function () {
      var _defaultConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(channel) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                channel: channel
              };
              _context4.n = 1;
              return (0, _SMSSettings.defaultConfig)(params);
            case 1:
              res = _context4.v;
              console.log('res', res);
              if (res.code === 0) {
                this.$message.success('设置成功');
                this.getConfig();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function defaultConfig(_x) {
        return _defaultConfig2.apply(this, arguments);
      }
      return defaultConfig;
    }()
  }
};